<template>
  	<v-dialog v-model="dialog" persistent max-width="700px" scrollable>
		<v-card tile>
			<v-card-title class="third--text" >
				<v-icon medium left color="primary">mdi-lock-reset</v-icon>
				<div class="title">Cambiar Contraseña</div>
			</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-4" style="max-height: 550px;">
            	<v-form v-model="valid" autocomplete="off" ref="formChangePassword" lazy-validation>
                	<v-container fluid>
                    	<v-row>
                             <v-col cols="12" sm="12" class="pb-0">
                                <v-text-field                        
                                    prepend-icon="mdi-security"
                                    name="password"
                                    label="Contraseña actual"
                                    :rules="rules.passwordA" 
                                    v-model="form.passwordA"
                                    autocomplete="new-password"
                                    outlined
                                    @click:append="showPassword1 = !showPassword1" :type="showPassword1 ? 'text' : 'password'" :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'" 
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="pb-0">
                                <v-text-field
                                    prepend-icon="mdi-security"
                                    name="password"
                                    label="Nueva Contraseña"
                                    :rules="rules.password" 
                                    v-model="form.password"
                                    autocomplete="new-password"
                                    outlined
                                    @click:append="showPassword2 = !showPassword2" :type="showPassword2 ? 'text' : 'password'" :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'" 
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="pb-0">
                                <v-text-field
                                    prepend-icon="mdi-security"
                                    name="passwordConfirmation"
                                    label="Repetir nueva contraseña"
                                    :rules="passwordConfirmationRule"
                                    v-model="form.passwordConfirmation"
                                    autocomplete="off"
                                    outlined
                                    @click:append="showPassword3 = !showPassword3" :type="showPassword3 ? 'text' : 'password'" :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>				
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-5">
            	<v-spacer></v-spacer>
                <v-btn color="primary" @click="validate" :disabled="!valid">Continuar</v-btn>
				<v-btn @click="dialog = !dialog; $emit('close')">Cancelar</v-btn> <!-- class="ms-auto" -->
            </v-card-actions>  
        </v-card>
  	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: "ChangePassword",
    data() {
        return {
            valid: false,
			dialog: true,
            showPassword1: false,
            showPassword2: false,
            showPassword3: false,
            form: {                
                passwordA: '',
                password: '',
                passwordConfirmation: '',
            },
            rules: {
                passwordA: [ 
                    v => !!v || 'Contraseña actual es requerida.', 
                    v => (v && v.length >= 6) || 'Contraseña actual debe ser igual o superior a 6 caracteres.', 
                    v => (v && v.length <= 16) || 'Contraseña actual no debe ser superior a 16 caracteres.' 
                ],
                password: [ 
                    v => !!v || 'Nueva contraseña es requerida.', 
                    v => (v && v.length >= 6) || 'Nueva contraseña debe ser igual o superior a 6 caracteres.', 
                    v => (v && v.length <= 16) || 'Nueva contraseña no debe ser superior a 16 caracteres.' 
                ],
            }
        }
    },
    computed: {
        passwordConfirmationRule(){
            const rules = [];
            if (this.form.password){
                const rule = v => (!!v && v) === this.form.password || 'Contraseñas no coinciden.'
                rules.push(rule)
            }
            return rules;
        },
    },
    methods: {
        ...mapActions({            
            change: 'auth/change'
        }),
        validate() {
            if (this.$refs.formChangePassword.validate()) {
                swal({ title: "¿Desea cambiar la contraseña?", icon: "warning", closeOnClickOutside: false, closeOnEsc: false,
                    buttons: {
                        cancel:{ text: "Cancelar", value: false, visible: true, closeModal: true },
                        confirm:{ text: "Enviar", value: true, visible: true, className: "primary", closeModal: false }
                    }
                })
                .then(enviar => {
                    if (!enviar) throw null;
                    var m = document.querySelector(".swal-button--cancel");
                    m.setAttribute("disabled", "disabled");
                    this.changePassword()
                })           
                .catch((error) => {
                    if(error) {
                        this.handleError(error)
                    }
                    else {
                        swal.stopLoading();
                        swal.close();
                    }
                });
            }
        },
        changePassword() {
             this.change(this.form).then((response) => {        
                swal({title: response.data.message, icon: "success", button: 'Close'}).then(cerrar => {                    
                    this.$emit('close');
                    localStorage.removeItem("user");
                    window.location = '/';
                })
                this.loading = false;
            })
            .catch((error) => {
                this.loading = false;
                if(error) {
                    this.handleError(error);
                }
                else {
                    swal.stopLoading();
                    swal.close();
                }
            });
        }
    }
}
</script>